import { createUseStyles } from '../../theme/theming';

const useDropdownStyles = createUseStyles((theme) => ({
  container: {
    backgroundColor: theme?.palette?.background?.default,
    display: 'flex',
    justifyContent: 'flex-start',
    userSelect: 'none',
    alignItems: 'center',
    position: 'relative',
    padding: '20px 24px',
    margin: '0 20px 0 0',
    '&:hover': {
      background: theme.palette.primary.lightest,
      borderRadius: '4px',
      '& $listBox': {
        display: 'flex'
      }
    }
  },
  label: {
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.main
  },
  icon: {
    marginLeft: '8px',
    transform: 'rotate(90deg)'
  },
  listBox: {
    display: 'none',
    position: 'absolute',
    top: '100%',
    right: '0',
    minWidth: '180px',
    backgroundColor: theme?.palette?.background?.default,
    boxShadow: '0 2px 8px rgb(10 22 41 / 10%)',
    borderRadius: theme?.shape?.borderRadius?.small,
    overflow: 'hidden',
    zIndex: '2',
    padding: '0',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    border: theme.borders.secondary
  },
  listItem: {
    backgroundColor: theme?.palette?.background?.default,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    padding: '10px 16px',
    cursor: 'pointer',
    color: theme.palette.primary.main,
    zIndex: 1
  },

  '@media screen and (max-width: 767px)': {}
}));

export default useDropdownStyles;
